import React, { useEffect, useState } from "react";
import Button from "../SelectValue/Button";
import postService from "../../Services/post-service";
import Pin from "./Pin";
import SelectBank from "../BankCard/SelectBank";
import getServices from "../../Services/get-service";
import TextBox from "../SelectValue/TextBox";
import SelectD from "./SelectD";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Skeleton from '@mui/material/Skeleton';

function NextofKim() {
  const [loading, setLoading] = useState(false);
  const [pin, setPin] = useState("");
  const [bank, setBank] = useState("");
  const [bankCode, setBankCode] = useState("");
  const [nextKinDetails, setNextKinDetails] = useState([]);
  const [accNo, setAccNo] = useState("");
  const [fullName, setFullName] = useState("");
  const [pNo, setPNo] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [relationship, setRelationship] = useState("");
  const [sex, setSex] = useState("");
  const [open, setOpen] = useState(false);
  const [isFetchingData, setIsFetchingData] = useState(true);
  const handleClose = () => setOpen(false);

  const dropdownOptions = [
    { key: "Select an option", value: "" },
    { key: "Male", value: "male" },
    { key: "Female", value: "female" },
  ];

  const dropdownChild = [
    { key: "Select an option", value: "" },
    { key: "Spouse", value: "spouse" },
    { key: "Parent", value: "parent" },
    { key: "Sibling", value: "sibling" },
    { key: "Others", value: "others" },
  ];
  const fetchNextOfKinData = () => {
    setIsFetchingData(true);
    getServices.getNextOfKin().then(
      (response) => {
        setIsFetchingData(false);
        setLoading(false);
        if (response.data.statusCode === 200) {
          const data = response.data.data;
          setNextKinDetails(data);
          setAccNo(data.accountNumber);
          setSex(data.gender);
          setAddress(data.address);
          setFullName(data.fullname);
          setPNo(data.phonenumber);
          setRelationship(data.relationship);
          setEmail(data.email);
          setBankCode(data.bank);
        }
      },
      (error) => {
        setIsFetchingData(false);
        setLoading(false);
        // toast.error(
        //   error?.response?.data?.description,
        //   { autoClose: 1000, toastId: "fetch-next-of-kin-error" }
        // );
        setNextKinDetails('');
      }
    );
  };
  useEffect(() => {
    fetchNextOfKinData();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    finalSubmit(e);
  };

  const finalSubmit = (e) => {
    if (e) e.preventDefault();
    setLoading(true);
    postService
      .createNextOfKin(
        fullName,
        pNo,
        relationship,
        bankCode,
        accNo,
        email,
        address,
        sex
      )
      .then(
        (response) => {
          setLoading(false);
          if (response.data.statusCode === 200) {
            toast.success(response.data.description, { autoClose: 1000 });
            fetchNextOfKinData();
          }
        },
        (error) => {
          setLoading(false);
          toast.error(error?.response?.data?.description, { autoClose: 1000 });
        },
      );
  };

  const isActive =
    accNo && bankCode && fullName && pNo && email && address && sex && relationship;

  const hasNextOfKin = Boolean(nextKinDetails && typeof nextKinDetails === 'object' && Object.keys(nextKinDetails).length > 0 && !Array.isArray(nextKinDetails));

  return (
    <div className="">
      <Pin
        open={open}
        handleClose={handleClose}
        pin={pin}
        setPin={setPin}
        onSubmit={finalSubmit}
        loading={loading}
      />
      <div className="">
        {isFetchingData ? (
          <div className="leading-[150%] animate-pulse">
            <Skeleton variant="text" width={200} height={32} sx={{ mb: 3 }} />
            {[1, 2].map((item) => (
              <div key={item} className="my-4 md:grid grid-cols-4 gap-5">
                <div className="flex flex-col justify-center">
                  <Skeleton variant="text" width={120} height={24} />
                </div>
                <div className="col-span-2">
                  <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: '8px' }} />
                </div>
              </div>
            ))}
            <Skeleton variant="text" width={250} height={32} sx={{ mt: 6, mb: 3 }} />
            {[1, 2, 3, 4, 5, 6].map((item) => (
              <div key={item} className="my-4 md:grid grid-cols-4 gap-5">
                <div className="flex flex-col justify-center">
                  <Skeleton variant="text" width={120} height={24} />
                </div>
                <div className="col-span-2">
                  <Skeleton variant="rectangular" width="100%" height={56} sx={{ borderRadius: '8px' }} />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="">
            <div className="leading-[150%]">
              <p className="text-[20px] font-[600] text-[#1E222B]">
                Bank Information
              </p>
              <div className=" my-10 md:grid grid-cols-4 gap-5">
                <div className=" flex flex-col justify-center">
                  <p className="text-[#1C1B1F] font-semibold text-[16px]">
                    Account Number
                  </p>
                </div>
                <div className=" col-span-2 ">
                  <TextBox
                    type="text"
                    label="Account Number"
                    value={accNo}
                    onChange={setAccNo}
                    disabled={hasNextOfKin}
                  />
                </div>
              </div>
              <div className="mb-7 mt-4 md:grid grid-cols-4 gap-5">
                <p className="text-[#1C1B1F] font-semibold text-[16px]">
                  Bank Name
                </p>
                <div className=" col-span-2">
                  <SelectBank
                    bName={setBank}
                    value={bankCode}
                    onChange={setBankCode}
                    disabled={hasNextOfKin}
                  />
                </div>
              </div>
              <p className="text-[20px] font-[600] text-[#1E222B] my-10">
                Next of Kin Personal Information
              </p>
              <div className=" my-4 md:grid grid-cols-4 gap-5">
                <div className=" flex flex-col justify-center">
                  <p className="text-[#1C1B1F] font-semibold text-[16px]">
                    Full Name
                  </p>
                </div>

                <div className=" col-span-2">
                  <TextBox
                    type="text"
                    label="Full Name"
                    value={fullName}
                    onChange={setFullName}
                    disabled={hasNextOfKin}
                  />
                </div>
              </div>
              <div className=" my-4 md:grid grid-cols-4 gap-5">
                <p className="text-[#1C1B1F] font-semibold text-[16px]">
                  Phone Number
                </p>
                <div className=" col-span-2">
                  <TextBox
                    type="tel"
                    label="Phone Number"
                    value={pNo}
                    onChange={setPNo}
                    disabled={hasNextOfKin}
                  />
                </div>
              </div>
              <div className=" my-4 md:grid grid-cols-4 gap-5">
                <p className="text-[#1C1B1F] font-semibold text-[16px]">Email</p>
                <div className=" col-span-2">
                  <TextBox
                    type="email"
                    label="Email"
                    value={email}
                    onChange={setEmail}
                    disabled={hasNextOfKin}
                  />
                </div>
              </div>
              <div className=" my-4 md:grid grid-cols-4 gap-5">
                <p className="text-[#1C1B1F] font-semibold text-[16px]">
                  Home Address
                </p>
                <div className=" col-span-2">
                  <TextBox
                    type="text"
                    label="Address "
                    value={address}
                    onChange={setAddress}
                    disabled={hasNextOfKin}
                  />
                </div>
              </div>
              <div className=" my-4 md:grid grid-cols-4 gap-5">
                <p className="text-[#1C1B1F] font-semibold text-[16px]">Gender</p>
                <div className=" col-span-2">
                  <SelectD
                    label="Select gender"
                    value={sex}
                    onChange={setSex}
                    options={dropdownOptions}
                    disabled={hasNextOfKin}
                  />
                </div>
              </div>

              <div className=" my-4 md:grid grid-cols-4 gap-5">
                <p className="text-[#1C1B1F] font-semibold text-[16px]">
                  Relationship
                </p>
                <div className=" col-span-2">
                  <SelectD
                    label="Relationship"
                    value={relationship}
                    onChange={setRelationship}
                    options={dropdownChild}
                    disabled={hasNextOfKin}
                  />
                </div>
              </div>
              {!hasNextOfKin && (
                <div className=" md:grid grid-cols-4 gap-5 mb-5 mt-6">
                  <div></div>
                  <div className=" col-span-2 flex gap-4">
                    <div className="w-full">
                      <Button name="Add Next Of Kin" bool={true} disabled={!isActive} isLoading={loading} />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default NextofKim;
